import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { obtenerTiendasCercanas } from "../geo/tiendasCercanas";
import { obtenerResumenResenas } from "../geo/resenas";

const MAX_SERVICIOS = 12;

/**
 * Servicios de las tiendas más cercanas al usuario (dentro del radio configurado).
 * Llama a setServicios con la lista y, opcionalmente, a onMeta({ fueraDeRango }).
 */
export const getServiciosCerca = async (ubicacionUsuario, userFavorites, setServicios, onMeta) => {
  try {
    const tiendas = await obtenerTiendasCercanas(ubicacionUsuario);
    const seleccion = [];

    for (const tienda of tiendas) {
      if (seleccion.length >= MAX_SERVICIOS) break;
      const serviciosTienda = await obtenerserviciosDeTienda(tienda.vendedorUid, userFavorites);
      for (const sv of serviciosTienda) {
        if (seleccion.length >= MAX_SERVICIOS) break;
        seleccion.push({ ...sv, distancia: tienda.distancia, tiendaNombre: tienda.nombre });
      }
    }

    // Las reseñas de servicios se guardan con el campo "idservicio"
    const resumen = await obtenerResumenResenas("idservicio", seleccion.map((s) => s.id));
    setServicios(
      seleccion.map((s) => {
        const r = resumen[s.id];
        return { ...s, calificacion: r ? r.suma / r.cantidad : 0, resennaCount: r ? r.cantidad : 0 };
      })
    );
    if (onMeta) onMeta({ fueraDeRango: tiendas.some((t) => t.fueraDeRango), sinTiendas: tiendas.length === 0 });
  } catch (error) {
    console.error("Error al obtener servicios cercanos:", error.message);
    setServicios([]);
  }
};

const obtenerserviciosDeTienda = async (tiendaId, userFavorites) => {
  try {
    const snap = await getDocs(query(collection(db, "servicios"), where("vendedorUid", "==", tiendaId)));
    const favoritos = (userFavorites && userFavorites.servicios) || [];
    return snap.docs
      .map((d) => ({ ...d.data(), id: d.id }))
      // Las rentas sin unidades no se ofrecen; los servicios por empleado siempre
      .filter((sv) => !sv.pausa && !sv.deshabilitado && (sv.tipoServicio !== "renta" || sv.stock > 0))
      .map((sv) => ({ ...sv, isFavorite: favoritos.includes(sv.id) }));
  } catch (error) {
    console.error("Error al obtener servicios de la tienda:", error.message);
    return [];
  }
};
